import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import dayjs from "dayjs"
import dayjsZhCN from "dayjs/locale/zh-cn";
import { ConfigProvider } from "antd";
import zhCN from "antd/lib/locale/zh_CN";
import { Provider } from "react-redux";
import store from './store/store'
import App from './App';
import './index.css';

dayjs.locale(dayjsZhCN);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <ConfigProvider locale={zhCN}>
      <App />
    </ConfigProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
